/** @format */

import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  DeleteOutlined,
  SaveOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { header } from "../../../../components/api/Header";
import swal from "sweetalert";
import { user_data } from "../../../../components/functions/usr";
import { getEnv } from "../../../../lib/env";
function Add({ date, setDate }) {
  if (user_data()) {
    if (user_data().region_id == 8) {
      console.log("ok");
    } else {
      window.location = "/ravotxoji";
    }
  } else {
    window.location = "/ravotxoji";
  }
  const [ldate, setLdate] = useState(date);
  const [data, setData] = useState("");
  useEffect(() => {
    const fetchDate = async () => {
      const res = await axios
        .get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/ravotxoji/daily?date=" +
            date,
          header()
        )
        .catch((e) => {
          console.log("Xato", e);
          alert("Server bilan aloqa yo'q");
        });
      if (res) {
        setData(res.data);
      }
    };
    if (date) {
      fetchDate();
    }
  }, [date]);
  const ortacha = (a, b) => {
    if (!a || typeof a == "undefined" || a === "" || a == 0) {
      return 0;
    }
    let s = parseFloat(a) / b;
    if (s % 1 == 0) return s;
    return s.toFixed(1);
  };
  const check = (a) => {
    if (!a || typeof a == "undefined" || a === "") {
      a = 0;
    }
    return parseFloat(a);
  };
  const setHandler = (v, t, s) => {
    let d = { ...data };
    let o7,
      o9 = 0;
    if (t === "r") {
      d["rovotxoji"][s] = v;
      let o7 =
        check(d["rovotxoji"]["1"]) +
        check(d["rovotxoji"]["3"]) +
        check(d["rovotxoji"]["5"]) +
        check(d["rovotxoji"]["7"]);
      let o9 =
        check(d["rovotxoji"]["9"]) +
        check(d["rovotxoji"]["11"]) +
        check(d["rovotxoji"]["13"]) +
        check(d["rovotxoji"]["15"]) +
        check(d["rovotxoji"]["17"]) +
        check(d["rovotxoji"]["19"]) +
        check(d["rovotxoji"]["21"]) +
        check(d["rovotxoji"]["23"]);
      d["ortacha7gacha"] = ortacha(o7, 4);
      d["ortacha9dan"] = ortacha(o9, 8);
    }
    if (t === "z") {
      d["ziaiddin"][s] = v;
    }
    setData(d);
  };
  const doIt = async (action) => {
    const res = await axios
      .post(
        getEnv('REACT_APP_BASE_URL') + "/v1/region/ravotxoji/" + action,
        { date, data },
        header()
      )
      .catch((e) => {
        console.log("Xato", e);
        alert("Server bilan aloqa yo'q!");
      });
    if (res) {
      if (res.data.status == 200) {
        swal("Muvaffaqiyatli", res.data.message, "success");
        setDate("");
        window.location = "/ravotxoji";
      } else {
        swal("Xato", res.data.message, "error");
      }
    }
  };
  const deletehandler = () => {
    let xa = window.confirm(
      date + " dagi ma'lumotlarni o'chirishni xoxlaysizmi?"
    );
    if (xa) {
      doIt("delete");
    }
  };
  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <ul className='list-unstyled list-inline'>
            <li className='list-inline-item'>
              <NavLink
                to='/ravotxoji'
                className='btn btn-sm btn-outline-primary d-flex align-items-center'>
                <ArrowLeftOutlined />
                &nbsp;&nbsp;&nbsp;Qaytish
              </NavLink>
            </li>
            <li className='list-inline-item'>
              {data ? (
                data["saved"] != 0 ? (
                  <NavLink
                    to='/ravotxoji'
                    className='btn btn-sm btn-outline-danger d-flex align-items-center'
                    onClick={() => deletehandler()}>
                    O'chirish&nbsp;&nbsp;&nbsp;
                    <DeleteOutlined />
                  </NavLink>
                ) : null
              ) : null}
            </li>

            <li className='list-inline-item'>
              <div className='d-flex'>
                <input
                  type='date'
                  className='form-control-sm form-control'
                  onChange={(e) => setLdate(e.target.value)}
                  value={ldate}
                />
                &nbsp;&nbsp;&nbsp;
                <button
                  className='btn btn-sm btn-outline-primary'
                  onClick={() => setDate(ldate)}>
                  Ok
                </button>
              </div>
            </li>
            <li className='list-inline-item'>
              {date ? null : " <--Sanani tanlang"}
            </li>
          </ul>
        </div>
      </div>
      <div className='table-responsive tableFixHead' id='tableFlexible'>
        <table
          className='table table-bordered table-style'
          style={{ width: "unset" }}>
          <thead>
            <tr>
              <th scope='col'>Soat</th>
              <th scope='col'>Zarafshon</th>
              <th scope='col'>{date}</th>
            </tr>
          </thead>
          {date ? (
            <tbody>
              <tr>
                <td rowSpan={2}>01:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["1"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 1)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["1"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 1)}
                  />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>03:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["3"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 3)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["3"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 3)}
                  />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>05:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["5"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 5)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["5"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 5)}
                  />
                </td>
              </tr>

              <tr>
                <td rowSpan={2}>07:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["7"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 7)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["7"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 7)}
                  />
                </td>
              </tr>

              <tr>
                <td rowSpan={2}>09:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["9"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 9)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["9"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 9)}
                  />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>11:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["11"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 11)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["11"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 11)}
                  />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>13:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["13"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 13)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["13"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 13)}
                  />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>15:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["15"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 15)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["15"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 15)}
                  />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>17:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["17"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 17)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["17"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 17)}
                  />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>19:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["19"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 19)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["19"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 19)}
                  />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>21:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["21"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 21)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["21"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 21)}
                  />
                </td>
              </tr>
              <tr>
                <td rowSpan={2}>23:00</td>
                <td>Ziatdin</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["ziaiddin"] ? data["ziaiddin"]["23"] : ""}
                    onChange={(e) => setHandler(e.target.value, "z", 23)}
                  />
                </td>
              </tr>
              <tr>
                <td>Ravotxoji</td>
                <td className='inserttr'>
                  <input
                    type='number'
                    className='insertable'
                    value={data["rovotxoji"] ? data["rovotxoji"]["23"] : ""}
                    onChange={(e) => setHandler(e.target.value, "r", 23)}
                  />
                </td>
              </tr>
            </tbody>
          ) : null}
        </table>
      </div>
      {data ? (
        <button className='btn btn-sm btn-primary' onClick={() => doIt("save")}>
          <SaveOutlined /> &nbsp;&nbsp;&nbsp;Saqlash
        </button>
      ) : null}
    </>
  );
}

export default Add;
